<template>
  <div class="informations">
    <v-layout wrap row>
      <v-flex lg6>
        <v-card flat>
          <v-card-title>Dados da Funcionalidade</v-card-title>
          <v-card-text>
            <v-layout class="mb-2" wrap row>
              <v-flex lg6>
                <h4 class="secondary--text">
                  Titulo
                </h4>
                <span class="grey--text darken-4 mt-4">{{ feature.title }}</span>
              </v-flex>
              <v-flex lg6>
                <h4 class="secondary--text">
                  Nome
                </h4>
                <span class="grey--text darken-4 mt-4">{{ feature.name }}</span>
              </v-flex>
              <v-flex lg6>
                <h4 class="secondary--text">
                  Tipo
                </h4>
                <span class="grey--text darken-4 mt-4">{{ feature.type }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex lg6>
        <v-card flat>
          <v-card-title>Actions</v-card-title>
          <v-card-text>
            <v-layout class="mb-2" wrap row>
              <v-flex lg6>
                <h4 class="secondary--text">
                  Actions
                </h4>
                <div v-for="(action, index) in feature.actions" :key="index" class="grey--text darken-4 mt-4">
                  {{ action.title }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>

export default {
  name: 'Informations',
  props: {
    feature: {
      type: Object,
      default: () => { }
    }
  },

}
</script>